import React, { useState } from 'react';

import Button from '@atlaskit/button';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import Projects from 'src/views/Admin/ConfigWithAccountsMapping/Rules/RulesTable/TableCells/Projects';
import Services from 'src/views/Admin/ConfigWithAccountsMapping/Rules/RulesTable/TableCells/Services';
import RuleFormWithContext from 'src/views/Admin/Modals/EditRuleModal/RuleForm';

const DomainBlock = ({ title, rules, setCurrentRuleId }) => {
  const renderedRules = rules.map(r => {
    return (
      <tr key={r.id} data-cy={`rule-table-row-${r.id}`}>
        <td><div><Button onClick={e => setCurrentRuleId(r.id)} appearance="link">{r.name}</Button></div></td>
        <td><Services {...r}/></td>
        <td><Projects {...r}/></td>
      </tr>
    );
  });

  return (
    <div style={{ maxWidth: 1400, margin: 'auto' }}>
      <br/>
      <br/>
      <h3 style={{ background: '#FFD' }}>{title}</h3>
      <div>
        <table>
          <thead>
            <tr>
              <th style={{ width: '20%' }}>Name</th>
              <th>Services</th>
              <th>Projects</th>
            </tr>
          </thead>
          <tbody>
            {renderedRules}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const RuleModal = ({ rules, currentRuleId, setCurrentRuleId }) => {
  const rule = rules.find(r => r.id === currentRuleId);
  const close = () => setCurrentRuleId(null);

  return (
    <ModalTransition>
      {rule && <Modal
        onClose={close}
        heading={rule.name}
        width="90%"
      >
        <RuleFormWithContext
          rule={rule}
          onSave={close}
          readonly
        />
      </Modal> }
    </ModalTransition>
  );
};

const RulesFileSelector = ({ setRules }) => {
  const loadFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = function () {
        const rules = JSON.parse(reader.result);
        setRules(rules);
      };
      reader.readAsBinaryString(file);
    }
  };

  return (
    <div style={{ margin: 'auto', width: '30%' }}>
      <label>select file with exported rules:</label><br/>
      <input type="file" onChange={loadFile}/>
      <br/>
    </div>
  );
};

const AllRulesPresenter = ({ rules }) => {
  const [currentRuleId, setCurrentRuleId] = useState(null);
  const byDomain = {};
  for (const { pd_account_base_url, ...rule } of rules) {
    byDomain[pd_account_base_url] = byDomain[pd_account_base_url] || [];
    byDomain[pd_account_base_url].push(rule);
  }

  return (
    <div>
      <RuleModal currentRuleId={currentRuleId} setCurrentRuleId={setCurrentRuleId} rules={rules}/>
      {Object
        .entries(byDomain)
        .sort(([, av], [, bv]) => JSON.stringify(bv).length - JSON.stringify(av).length)
        .map(([title, rules]) => (
          <DomainBlock
            key={title}
            title={title}
            rules={rules}
            setCurrentRuleId={setCurrentRuleId}
          />
        )
        )}
    </div>
  );
};

const AllRulesOverview = () => {
  const [rules, setRules] = useState(null);
  return (
    <div>
      <RulesFileSelector setRules={setRules}/>
      {rules && <AllRulesPresenter rules={rules}/>}
    </div>
  );
};


export default AllRulesOverview;
